import { Block } from '@comp/crRender'
import { translate } from '@/utils/langUtils';
import { Icon } from '@iconify/react/dist/iconify.js'
import moment from 'moment';
import { useEffect, useRef } from 'react'
import { LoadListDefault, useGet } from '@apiHooks/useGet';

const ChatContent = ({ getMessagesAPI, providerOrderId, messages, setMessages, chatWidgetRef }) => {

    const messagesEndRef = useRef<HTMLDivElement>(null);

    const { result: messagesData } = useGet({
        ...LoadListDefault,
        endPoint: getMessagesAPI,
        params: [providerOrderId],
        shortPullTime: 5000,
        defaultValue: [],
        allowFetch: true,

    });

    useEffect(() => {
        if (messagesData?.length > 0) {
            let reversedMessages = messagesData.reverse();
            setMessages(reversedMessages);
        }
    }, [messagesData]);

    const formatTimestamp = (timestamp: string) => {
        const msgDate = moment(timestamp);
        const today = moment().startOf("day");
        const yesterday = moment().subtract(1, "day").startOf("day");

        if (msgDate.isSame(today, "day")) {
            return msgDate.format("HH:mm");
        } else if (msgDate.isSame(yesterday, "day")) {
            return translate("Yesterday") + " " + msgDate.format("HH:mm");
        } else {
            return msgDate.format("MMM DD, HH:mm");
        }
    };

    return (
        <>
            {messages.map((message) => (
                <div key={message.id} ref={messagesEndRef} className={`chat-message ${message.isMine ? "own-message" : "other-message"}`}>
                    <div className="message-avatar">
                        <Icon width={20} icon={!message.isMine ? "mdi:account-circle" : "mdi:hospital-building"} />
                    </div>
                    <div className="message-content">

                        <Block isRender={!!message.message} className="message-body">
                            <p>{message.message}</p>
                            <span className="message-time">{formatTimestamp(message.date)}</span>
                        </Block>
                        <Block isRender={!!message.attachmentsPath} className="message-attachments">
                            <a href={message.attachmentsPath} target="_blank" rel="noopener noreferrer">
                                <Icon icon="mdi:file-document" width={20} />
                                <span>{message.attachmentsPath}</span>
                                <Icon icon="mdi:download" width={16} />
                            </a>
                        </Block>
                    </div>
                </div>
            ))}
            <div ref={chatWidgetRef}>
            </div>
        </>
    )
}

export default ChatContent